module.exports = "<div class=\"preloader-wrapper active  {{spinnerType}}\">\n    <mdb-Spinners mdbSpinners mode=\"indeterminate\"></mdb-Spinners>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/typescripts/pro/progressbars/progress-spinner.component.html
// module id = ./src/app/typescripts/pro/progressbars/progress-spinner.component.html
// module chunks = main